export const toEnglishNumbers = (value) => {
  if (!value) return value;

  return value
    .toString()
    .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
    .replace(/,/g, ""); // حذف کاما اگر وجود داشت
};